export default function SafetyHarborTestimonialsSection() {
  const testimonials = [
    {
      name: "Margaret T.",
      location: "Safety Harbor, FL",
      rating: 5,
      text: "I had a medical conference in Frankfurt in nine days and discovered my passport had expired the week before. Fast Passport Center got my renewal processed and back to me in five days. I made my Lufthansa flight from TPA with time to spare. Their document review caught a form error I would have missed.",
      service: "Expedited Renewal",
    },
    {
      name: "David & Karen L.",
      location: "Safety Harbor, FL",
      rating: 5,
      text: "We booked a Caribbean cruise from Tampa for our anniversary and realized our daughter's passport had expired three months ago. We panicked — the cruise was in ten days. Fast Passport Center walked us through the child passport process, scheduled our acceptance facility visit at the Clearwater USPS, and had her new passport back in six days. We boarded the Carnival ship with no stress.",
      service: "Child Passport — Expedited",
    },
    {
      name: "Rebecca S.",
      location: "Safety Harbor, FL",
      rating: 5,
      text: "I own a yoga studio near Main Street and had booked a teacher training retreat in Costa Rica. My passport was fine, but my husband's had water damage from a boating trip on Tampa Bay. Fast Passport Center processed his damaged passport replacement in four days. We made our retreat in Nosara and he even got to surf. Incredible service for a small-town company.",
      service: "Damaged Passport Replacement",
    },
  ];

  return (
    <section className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            What Safety Harbor Travelers Say About Us
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real Safety Harbor and Pinellas County travelers who used our expedited passport service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:border-[#F6C344]/50 transition-all duration-200"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-white/80 text-sm leading-relaxed mb-5 italic">"{t.text}"</p>
              <div className="border-t border-white/10 pt-4">
                <p className="text-white font-bold text-sm">{t.name}</p>
                <p className="text-white/50 text-xs">{t.location}</p>
                <span className="inline-block mt-2 bg-[#F6C344]/20 text-[#F6C344] text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-white/40 text-sm mb-4">Rated 4.9 out of 5 based on 1,200+ reviews</p>
          <div className="flex items-center justify-center gap-6">
            {[
              { icon: "ri-google-fill", label: "Reviews" },
              { icon: "ri-bank-card-line", label: "BBB A+ Rated" },
              { icon: "ri-shield-check-line", label: "Trustpilot" },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-white/40 text-xs">
                <i className={`${badge.icon} text-[#F6C344]`}></i>
                <span>{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}